// =============================================================
// MISA · Atelier 04 — PDP interactions (Arabic / RTL)
// =============================================================

document.addEventListener('DOMContentLoaded', () => {

  // ---- Announce ticker
  const tickerItems = document.querySelectorAll('.ticker-item');
  if (tickerItems.length > 1) {
    let current = 0;
    setInterval(() => {
      const next = (current + 1) % tickerItems.length;
      tickerItems[current].classList.add('is-leaving');
      tickerItems[current].classList.remove('is-active');
      tickerItems[next].classList.add('is-active');
      const leaving = tickerItems[current];
      setTimeout(() => leaving.classList.remove('is-leaving'), 500);
      current = next;
    }, 3500);
  }

  const breakpoint = 720;
  const isMobile = () => window.innerWidth <= breakpoint;

  const formatPrice = (n) => n.toFixed(2);

  // ---- 1. Thumbnail gallery
  const thumbs = document.querySelectorAll('.thumb');
  const mainImage = document.getElementById('mainImage');
  const capRight = document.querySelector('.stage-cap .cap-r');
  const total = thumbs.length;

  thumbs.forEach((thumb, idx) => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');

      const img = thumb.querySelector('img');
      if (img && mainImage) {
        const newSrc = img.src.replace('w=180&h=240', 'w=900&h=1200');
        mainImage.style.opacity = '0';
        setTimeout(() => {
          mainImage.src = newSrc;
          mainImage.style.opacity = '1';
        }, 200);
      }

      if (capRight) {
        const num = String(idx + 1).padStart(2, '0');
        const tot = String(total).padStart(2, '0');
        capRight.textContent = `${num} / ${tot}`;
      }
    });
  });

  if (mainImage) {
    mainImage.style.transition = 'opacity .3s ease';
  }

  // ---- 2. Color swatches
  document.querySelectorAll('.swatch').forEach(sw => {
    sw.addEventListener('click', () => {
      const variation = sw.closest('.variation');
      variation.querySelectorAll('.swatch').forEach(s => {
        s.classList.remove('is-active');
        const dot = s.querySelector('.swatch-dot');
        const oldCheck = dot && dot.querySelector('svg');
        if (oldCheck) oldCheck.remove();
      });
      sw.classList.add('is-active');

      const dot = sw.querySelector('.swatch-dot');
      if (dot && !dot.querySelector('svg')) {
        dot.insertAdjacentHTML('beforeend',
          '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.5"><polyline points="5 12 10 17 19 7"/></svg>'
        );
      }

      const valueEl = variation.querySelector('.opt-value');
      if (valueEl) valueEl.textContent = sw.getAttribute('aria-label') || '';
    });
  });

  // ---- 3. Sizes
  const sizeNamesAr = {
    S: 'صغير',
    M: 'متوسط',
    L: 'كبير',
    XL: 'كبير جداً',
    XXL: 'كبير مضاعف'
  };

  document.querySelectorAll('.size-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const variation = btn.closest('.variation');
      variation.querySelectorAll('.size-btn').forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      const code = btn.textContent.trim();
      const valueEl = variation.querySelector('.opt-value');
      if (valueEl) valueEl.textContent = sizeNamesAr[code] || code;
    });
  });

  const recAction = document.querySelector('.rec-action');
  if (recAction) {
    recAction.addEventListener('click', () => {
      const variation = recAction.closest('.variation');
      const target = variation ? Array.from(variation.querySelectorAll('.size-btn')).find(b => b.textContent.trim() === 'M') : null;
      if (target) target.click();
    });
  }

  // ---- 4. Quantity
  const qtyInput = document.querySelector('.qty-input');
  const minus = document.querySelector('.qty-btn.minus');
  const plus = document.querySelector('.qty-btn.plus');
  const cartPriceEl = document.querySelector('.btn-cart-r');
  const unitPrice = 650; // د.م.
  const max = 8;

  const updateCartPrice = () => {
    const qty = parseInt(qtyInput.value, 10) || 1;
    if (cartPriceEl) cartPriceEl.textContent = `${formatPrice(unitPrice * qty)} د.م. ←`;
  };

  if (qtyInput && minus && plus) {
    minus.addEventListener('click', () => {
      let v = parseInt(qtyInput.value, 10);
      if (v > 1) qtyInput.value = v - 1;
      updateCartPrice();
    });
    plus.addEventListener('click', () => {
      let v = parseInt(qtyInput.value, 10);
      if (v < max) qtyInput.value = v + 1;
      updateCartPrice();
    });
    qtyInput.addEventListener('change', () => {
      let v = parseInt(qtyInput.value, 10);
      if (isNaN(v) || v < 1) v = 1;
      if (v > max) v = max;
      qtyInput.value = v;
      updateCartPrice();
    });
  }

  // ---- 5. Tabs / Accordion
  const tabs = document.querySelectorAll('.tab');
  const panels = document.querySelectorAll('.panel');

  const activatePanel = (id) => {
    tabs.forEach(t => t.classList.toggle('is-active', t.dataset.target === id));
    panels.forEach(p => p.classList.toggle('is-active', p.id === id));
  };

  tabs.forEach(tab => {
    tab.addEventListener('click', () => activatePanel(tab.dataset.target));
  });

  const accHeads = document.querySelectorAll('.acc-head');
  accHeads.forEach(head => {
    head.addEventListener('click', () => {
      if (!isMobile()) return;
      const body = head.nextElementSibling;
      const isOpen = head.classList.contains('is-open');

      accHeads.forEach(h => {
        h.classList.remove('is-open');
        if (h.nextElementSibling) h.nextElementSibling.classList.remove('is-open');
      });

      if (!isOpen) {
        head.classList.add('is-open');
        body.classList.add('is-open');
      }
    });
  });

  // ---- 6. Resize sync
  let resizeTimer;
  let lastWidth = window.innerWidth;
  window.addEventListener('resize', () => {
    if (window.innerWidth === lastWidth) return; // Ignore height-only changes (mobile address bar)
    lastWidth = window.innerWidth;

    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      if (!isMobile()) {
        const anyActive = Array.from(panels).some(p => p.classList.contains('is-active'));
        if (!anyActive && panels.length) activatePanel(panels[0].id);
      } else {
        const first = document.querySelector('.acc-head');
        if (first && !document.querySelector('.acc-head.is-open')) {
          first.classList.add('is-open');
          first.nextElementSibling.classList.add('is-open');
        }
      }
    }, 120);
  });

  // ---- 7. Sticky header shadow on scroll
  const header = document.querySelector('.site-header');
  window.addEventListener('scroll', () => {
    if (header) {
      header.style.boxShadow = window.scrollY > 8 ? '0 2px 18px rgba(28,24,20,0.06)' : 'none';
    }
  });

  // ---- 8. Title staggered reveal on load
  const titleLines = document.querySelectorAll('.title .title-line');
  titleLines.forEach((line, i) => {
    line.style.opacity = '0';
    line.style.transform = 'translateY(18px)';
    line.style.transition = `opacity .7s ease ${i * 0.12}s, transform .7s cubic-bezier(.2,.7,.2,1) ${i * 0.12}s`;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        line.style.opacity = '1';
        line.style.transform = 'translateY(0)';
      });
    });
  });
});
